import TeacherTasks from './component';
import _routes from './routes';

export default TeacherTasks;
export const routes = _routes;



// WEBPACK FOOTER //
// ./containers/UserDashboard/TeacherTasks/index.js